export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`marquee-wrap relative overflow-hidden select-none ${className}`} aria-hidden="true">
      <div className="marquee-track" style={{ "--marquee-dur": "38s" }}>
        {row.map((it, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display italic text-2xl sm:text-3xl md:text-4xl text-foreground/80 px-6">
              {it}
            </span>
            <span className="text-primary text-lg">&#9679;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
